import { IconButton } from '@mui/material';
import Refresh from '@mui/icons-material/Refresh';
import { projectListSettingsAtom } from 'shared/_model/project/project-list/store';
import { PageFiltersIconButton } from 'shared/_components/page/page-filters-icon-buton';

export default function ProjectListActionsLeft({ refresh }: {refresh: () => Promise<void>|void}) {
	return (
		<>
			<PageFiltersIconButton settingsAtom={projectListSettingsAtom} />
			<IconButton onClick={refresh}>
				<Refresh />
			</IconButton>
		</>
	);
}
